export default "__VITE_ASSET__DSLXnPQK__"